module.exports = __webpack_public_path__ + "img/diamond.0b298427.png";